import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { coolGrey, grape, softGreen } from 'lib/css/colors';

function CopyableText({ text, tooltipText = 'Copy', children }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = e => {
    e.stopPropagation();
    navigator.clipboard.writeText(text || '');
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className={css(styles.container)}>
      {children || <span>{text}</span>}
      <OverlayTrigger overlay={<Tooltip>{copied ? 'Copied!' : tooltipText}</Tooltip>}>
        <FontAwesomeIcon
          icon={copied ? faCheck : faCopy}
          className={css(styles.icon, copied && styles.iconSuccess)}
          onClick={handleCopy}
          aria-label={tooltipText}
        />
      </OverlayTrigger>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
  },
  icon: {
    fontSize: 15,
    color: coolGrey,
    cursor: 'pointer',
    opacity: 0.45,
    flexShrink: 0,
    transition: 'opacity 0.15s, color 0.15s',
    ':hover': {
      opacity: 1,
      color: grape,
    },
  },
  iconSuccess: {
    color: softGreen,
    opacity: 1,
  },
});

CopyableText.propTypes = {
  text: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  children: PropTypes.node,
};

export default CopyableText;
